import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, notification } from 'antd';
import {
	Logo,
	Title,
	XForm,
	XLottie,
	XThemeLottieCard,
} from '../Login/LoginStyle';
import { CenterWrapper, XPara1 } from './ForgotEmailPasswordStyle';
import { Button, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import LoginAnimation from '../../json/Reclaim.json';
import {
	XContainer,
	XThemeContainer,
	XThemeGradientButton,
} from '../../styles/GlobalThemeStyle';
import Navbar from 'react-bootstrap/Navbar';
import { handleInputChange } from '../../utils/formFunctions';
// Actions
import {
	sendPasswordResetEmailApi,
	sendPasswordResetEmailReset,
} from '../../actions/sendPasswordResetEmailAction';
import {
	XTheme2Button,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';

const Forgot = (props) => {
	const {
		sendPasswordResetEmail,
		sendPasswordResetEmailReset,
		sendPasswordResetEmailState,
	} = props;
	const [form] = XForm.useForm();
	const [formData, setFormData] = useState({});
	const navigate = useNavigate();

	useEffect(() => {
		if (sendPasswordResetEmailState.apiState === 'success') {
			localStorage.setItem('email', formData.email);
			sendPasswordResetEmailReset();
			navigate('/verify-otp');
		} else if (sendPasswordResetEmailState.apiState === 'error') {
			notification.error({
				message: sendPasswordResetEmailState.message,
			});
			sendPasswordResetEmailReset();
		}
	}, [sendPasswordResetEmailState]);
	useEffect(() => {
		document.body.classList.add('bodyOverflowHideImageBg');
		return () => {
			document.body.classList.remove('bodyOverflowHideImageBg');
		};
	}, []);
	return (
		<XThemeContainer fluid>
			<Row className="align-items-center my-5" gutter={[15, 15]}>
				<Col xs={24} className="d-flex justify-content-start">
					<span className="logo">
						<img
							style={{ width: 100 }}
							src={'/images/reclaim-revolution-logo.svg'}
							alt="logo"
						/>
					</span>
				</Col>
			</Row>
			<CenterWrapper className="align-items-center h-auto">
				<Row className="align-items-center w-100">
					<Col
						xs={{ span: 24, offset: 0 }}
						sm={{ span: 24, offset: 0 }}
						md={{ span: 12, offset: 6 }}
						lg={{ span: 6, offset: 9 }}
					>
						<div className="w-50 m-auto text-center">
							<XThemeLottieCard>
								<XLottie
									animationData={LoginAnimation}
									loop={true}
								/>
							</XThemeLottieCard>
						</div>
						<XTheme2MainTitle className="my-4 text-center">
							Forgot password
						</XTheme2MainTitle>
						<XPara1 className="mb-4 text-center">
							Enter the email address associated with your account
							and we'll send you a link to reset your password
						</XPara1>

						<XForm
							form={form}
							name="loginForm"
							layout="vertical"
							autoComplete="off"
							onFinish={() => sendPasswordResetEmail(formData)}
							className="w-100"
						>
							<XForm.Item
								name="email"
								// label="Email Address"
								rules={[
									{
										required: true,
										message: 'Please enter email address',
									},
								]}
							>
								<Input
									size="large"
									name="email"
									placeholder="Enter Email Address"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XForm.Item>

							<XForm.Item className="mt-4">
								<XTheme2Button
									htmlType="submit"
									type="primary"
									className="w-100 py-4"
								>
									Send OTP on Email
								</XTheme2Button>
							</XForm.Item>
						</XForm>
					</Col>
					{/* <Col
						xs={{ span: 24, order: 1 }}
						sm={{ span: 24, order: 1 }}
						lg={{ span: 12, offset: 3, order: 2 }}
						className="text-center"
					>
						<Navbar.Brand href="/">
							<Logo className="mobileLogo">
								<img
									className="img-fluid"
									src="./images/logo.svg"
									alt="logo"
								/>
							</Logo>
						</Navbar.Brand>
						<XThemeLottieCard className="mobileCard">
							<XLottie
								animationData={LoginAnimation}
								loop={true}
							/>
						</XThemeLottieCard>
					</Col> */}
				</Row>
			</CenterWrapper>
		</XThemeContainer>
	);
};

const mapStateToProps = (state) => ({
	sendPasswordResetEmailState: state.sendPasswordResetEmail,
});

const mapDispatchToProps = (dispatch) => ({
	sendPasswordResetEmail: (params) =>
		dispatch(sendPasswordResetEmailApi(params)),
	sendPasswordResetEmailReset: () => dispatch(sendPasswordResetEmailReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Forgot);
